export default "<p>device works!</p>\n";